import { useCallback } from "react";
import { useQueryClient } from "react-query";

export function useInvalidateEntityNotes(): () => void {
    const queryClient = useQueryClient();
    return useCallback(() => {
        queryClient.invalidateQueries("getNotesForEntity");
        queryClient.invalidateQueries("getActivityFeed");
    }, [queryClient]);
}
